<template>
    <div class="corpus" :class="{'corpusDark' : isDark}">
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
            <!-- 通知 -->
            <van-notice-bar
                left-icon="volume-o"
                :text="noticeString"
                @replay="replay"
                ref="noticeBar"
            />
            <!-- 模型宫格 -->
            <div class="gridBox">
                <div class="gridVisual" @scroll="handleScroll($event)">
                    <van-grid class="gridUl" id="vanGridUl" :style="{width: girdNum * 20 + '%'}" :border="false" :column-num="girdNum">
                        <van-grid-item class="gridLi" v-for="(ele, i) in enterList" :key="i" @click="goModelList(ele.data_type, ele)">
                            <van-image :src="ele.h5_icon" />
                            <div class="gridName">{{ele.sub_name ? ele.sub_name : ele.name}}</div>
                            <div v-if="(ele.buy === '0' && ele.corner_url) || (ele.data_type === '26' && ele.corner_url)" class="gridLable corner">
                                <img :src="ele.corner_url" alt="">
                            </div>
                            <!-- <div v-else-if="ele.buy === '0'" :class="{'gridLable':true, 'none':ele.buy_info === 0}">{{ele.buy_info === 0 ? '' : (ele.buy_info + '人购买')}}</div> -->
                            <div class="gridLable bought" v-else-if="ele.buy === '1' || ele.buy === '2'">使用中</div>
                            <div class="bottomTips" v-if="ele.tag">{{ ele.tag }}</div>
                        </van-grid-item>
                    </van-grid>
                    <div class="scrollBarBox">
                        <div class="scrollBack" ref="scrollback">
                            <div class="scrollBar" ref="scrollbar"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 广告位 -->
            <div v-if="bannerList.length > 0" class="banner">
                <img :src="bannerList[0].imgurl" alt="" @click="openUrlInApp(bannerList[0])" />
            </div>
            <!-- 海外专家 -->
            <div v-if="corpusList.abroad_data && !Array.isArray(corpusList.abroad_data)" class="overseasPart">
                <OverSeas :overseasData="corpusList.abroad_data" @goDetail="goModelList"></OverSeas>
            </div>
            <!-- 情报 -->
            <div v-if="corpusList.quick_data && !Array.isArray(corpusList.quick_data)" class="informationPart">
                <Information :information="corpusList.quick_data" @goDetail="goModelList"></Information>
            </div>
            <!-- Margin -->
            <div v-if="corpusList.margin_data && !Array.isArray(corpusList.margin_data)" class="poissonPart">
                <Margin :marginData="corpusList.margin_data" @goDetail="goModelList"></Margin>
            </div>
            <!-- 冷门 -->
            <div v-if="corpusList.cool_data && !Array.isArray(corpusList.cool_data)" class="coldPart">
                <Cold :coolData="corpusList.cool_data" @goDetail="goModelList"></Cold>
            </div>
            <!-- 泊松 -->
            <div v-if="corpusList.poisson_data && !Array.isArray(corpusList.poisson_data)" class="poissonPart">
                <Poisson :poissonData="corpusList.poisson_data" @goDetail="goModelList"></Poisson>
            </div>
            <!-- 全维预测 -->
            <div v-if="corpusList.all_data && !Array.isArray(corpusList.all_data)" class="fullForecastPart">
                <FullForecast :allData="corpusList.all_data" @goDetail="goModelList"></FullForecast>
            </div>
            <!-- 指数 -->
            <div v-if="corpusList.dis_data && !Array.isArray(corpusList.dis_data)" class="poissonPart">
                <OddsWave :disData="corpusList.dis_data" @goDetail="goModelList"></OddsWave>
            </div>
            <!-- 大数据报告 -->
            <div v-if="corpusList.big_data && !Array.isArray(corpusList.big_data)" class="bigReportPart">
                <BigReport :bigData="corpusList.big_data" @goDetail="goModelList"></BigReport>
            </div>
            <!-- 庄家态度 -->
            <div v-if="corpusList.banker_data && !Array.isArray(corpusList.banker_data)" class="poissonPart">
                <BankerAttitude :bankerData="corpusList.banker_data" @goDetail="goModelList"></BankerAttitude>
            </div>
            <!-- 篮球智导 -->
            <div v-if="corpusList.ai_data && !Array.isArray(corpusList.ai_data)" class="poissonPart">
                <AiBasketball :aiData="corpusList.ai_data" @goDetail="goModelList"></AiBasketball>
            </div>
            <div class="placeholder"></div>
            <loading v-if="loading" :isDark="isDark"/>
        </van-pull-refresh>
    </div>
</template>

<script>
import { getDataModelIndex, getDataModelBanner, getModelCorpus } from '../../api/api'
import { getQueryVariable, handleBannerPrams, isJHApp, isJHApphm, getAppV } from "../../utils/base";
import jsbridg from '../../utils/jsbridg'
import Loading from '../../components/common/Loading.vue'
import Information from '../../components/datamodel/information.vue'
import Cold from '../../components/datamodel/coldAnalysis.vue'
import Poisson from '../../components/datamodel/poisson.vue'
import BigReport from '../../components/datamodel/bigReport.vue'
import FullForecast from '../../components/datamodel/fullForecast.vue'
import OddsWave from '../../components/datamodel/oddsWave.vue'
import BankerAttitude from '../../components/datamodel/bankerAttitude.vue'
import AiBasketball from '../../components/datamodel/aiBasketball.vue'
import Margin from '../../components/datamodel/margin.vue'
import OverSeas from '../../components/datamodel/overseas.vue'
export default {
    name: 'corpus',
    components: {
        Loading,
        Information,
        Cold,
        Poisson,
        BigReport,
        FullForecast,
        OddsWave,
        BankerAttitude,
        AiBasketball,
        Margin,
        OverSeas
    },
    data () {
        return {
            loading: false,
            girdNum: 6,
            barLeft: 0,
            noticeList: [], // 跑马灯列表
            noticeString: "", // 跑马灯转成字符串
            enterList: [], // 入口列表
            enterObject: {}, // 入口对应跳转
            bannerList: [], // 轮播图列表
            corpusList: {} // 模型列表
        }
    },
    created () {
        const self = this;
        self.loading = true;
        self.initData();
        // self.getBanner();
        self.getModelCorpusList();
        document.getElementsByTagName('title')[0].innerHTML = "数据模型"
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    methods: {
        replay () {
            this.$refs.noticeBar.reset()
        },
        onRefresh () {
            this.loading = true;
            this.initData();
            // this.getBanner();
            this.getModelCorpusList();
        },
        // 入口列表
        async initData () {
            const src = getQueryVariable('src');
            const arr = handleBannerPrams(src);
            const res = await getDataModelIndex({
                device: arr[0],
                channel: arr[1],
                version: arr[2],
                v: arr[2],
                src: src
            })
            if (res.errno === 0) {
                this.loading = false;
                if (res.data) {
                    this.enterList = res.data.list || [];
                    this.noticeList = res.data.hit_data || [];
                    if (this.noticeList.length > 0) {
                        this.noticeList.map((ele, index) => {
                            if (index < this.noticeList.length - 1) {
                                this.noticeString += ('恭喜' + ele.user_name + '购买了' + ele.data_type_name + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0');
                            } else {
                                this.noticeString += ('恭喜' + ele.user_name + '购买了' + ele.data_type_name);
                            }
                        })
                    }
                    this.girdNum = Math.ceil(this.enterList.length / 2);
                    if (this.enterList.length > 0) {
                        let h5Url = "https://test-h6.jihai8.com/page/daily_list?type=";
                        if (process.env.NODE_ENV === 'development') {
                            h5Url = 'https://test-h6.jihai8.com/page/daily_list?type='
                        }
                        this.enterList.map((ele, index) => {
                            if (ele.data_type === '15' || ele.data_type === '20') {
                                this.enterObject[ele.data_type] = h5Url + ele.data_type;
                            } else {
                                this.enterObject[ele.data_type] = ele.url
                            }
                        })
                        console.log(this.enterObject);
                    }
                }
            } else {
                this.$toast(res.errmsg);
                this.loading = false;
            }
        },
        // 广告位
        async getBanner () {
            const src = getQueryVariable('src');
            const arr = handleBannerPrams(src);
            const res = await getDataModelBanner({
                type: 23,
                device: arr[0],
                channel: arr[1],
                version: arr[2]
            })
            if (res.errno === 0) {
                this.loading = false;
                if (res.data) {
                    this.bannerList = res.data || [];
                }
            } else {
                this.$toast(res.errmsg);
                this.loading = false;
            }
        },
        // 模型列表
        async getModelCorpusList () {
            const src = getQueryVariable('src');
            const arr = handleBannerPrams(src);
            const res = await getModelCorpus({
                device: arr[0],
                channel: arr[1],
                version: arr[2],
                v: arr[2],
                src: src
            })
            if (res.errno === 0) {
                this.loading = false;
                if (res.data) {
                    this.corpusList = res.data || {};
                }
            } else {
                this.$toast(res.errmsg);
                this.loading = false;
            }
        },
        // 跳转模型列表页
        goModelList (type, item) {
            const src = getQueryVariable('src');
            const arr = handleBannerPrams(src);
            if (!type) {
                return;
            }
            if (isJHApp() && !isJHApphm()) {
                if (arr[2] * 1 >= 441 && !isJHApphm()) {
                    if (type * 1 === 15 || type * 1 === 20) {
                        jsbridg.goWebview({
                            code: type * 1 === 15 ? '534' : '535',
                            jumptype: 1
                        });
                    } else if (arr[2] * 1 >= 443 && type * 1 === 24 && arr[0] === "android") {
                        jsbridg.goWebview({
                            code: 538,
                            jumptype: 1
                        });
                    } else if (arr[2] * 1 >= 464 && (type * 1 === 18 || type * 1 === 17 || type * 1 === 16 || type * 1 === 21 || type * 1 === 15 || type * 1 === 20)) {
                        const codeMap = {
                            15: 534,
                            16: 542,
                            17: 540,
                            18: 541,
                            21: 543,
                            20: 535
                        };
                        jsbridg.goWebview({
                            code: codeMap[type * 1],
                            jumptype: 1
                        });
                    } else {
                        jsbridg.goWebview({
                            url: this.enterObject[type],
                            jumptype: 2
                        });
                    }
                } else {
                    jsbridg.goWebview({
                        url: this.enterObject[type],
                        jumptype: 2
                    });
                }
            } else {
                if (isJHApphm()) {
                    if (type * 1 === 20 && getAppV() * 1 > 464) {
                        jsbridg.goWebview({
                            code: 535,
                            jumptype: 1
                        });
                    } else {
                        jsbridg.goWebview({
                            url: this.enterObject[type],
                            jumptype: 2
                        });
                    }
                } else {
                    window.open(this.enterObject[type]);
                }
            }
        },
        // 滚动条效果
        handleScroll ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            const _multiple = $event.srcElement.scrollLeft / (document.getElementById('vanGridUl').offsetWidth - $event.srcElement.offsetWidth);
            const _last = _multiple * (this.$refs.scrollback.offsetWidth - this.$refs.scrollbar.offsetWidth);
            this.$refs.scrollbar.style.transform = `translate(` + _last + `px)`;
        },
        // 广告位跳转
        openUrlInApp (item) {
            let json = {}
            if (item.jumptype === "3") {
                // 浏览器
                json = {
                    url: item.url,
                    jumptype: 3
                }
            } else if (item.jumptype === "2") {
                // 客户端webview
                json = {
                    url: item.url,
                    jumptype: 2
                }
            } else if (item.jumptype === "1") {
                // 客户端原生
                let jumpParams = "";
                if (item.params) {
                    if (item.params.indexOf("#sign_in=0") > -1) {
                        jumpParams = item.params.replace("#sign_in=0", "");
                    } else if (item.params.indexOf("&sign_in=0") > -1) {
                        jumpParams = item.params.replace("&sign_in=0", "");
                    } else if (item.params.indexOf("sign_in=0") > -1) {
                        jumpParams = item.params.replace("sign_in=0", "");
                    } else {
                        jumpParams = item.params;
                    }
                    json = {
                        code: item.code,
                        params: jumpParams,
                        jumptype: 1
                    }
                }
            }
            jsbridg.goWebview(json);
        }
    }
}
</script>

<style lang="less" scoped>
.van-dialog{
    background-color: transparent;
}
.corpus{
    width: 100%;
    height: 100%;
    .van-notice-bar{
        background: #EAF4FE;
        color: #169AFF;
    }
    .gridBox{
        position: relative;
        padding: 12px 14px;
        border-radius: 5px;
        background: #F5F5F5;
        .gridVisual{
            width: 100%;
            max-width: 100%;
            height: auto;
            padding: 10px 0 4px;
            background: #FFFFFF;
            border-radius: 5px;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            overflow-x: scroll;
            overflow-y: hidden;
            .gridUl{
                // padding: 0 5px;
                .gridLi{
                    position: relative;
                    margin-bottom: 10px;
                    /deep/.van-grid-item__content {
                        padding: 0;
                        .gridLable{
                            position: absolute;
                            top: 0;
                            left: 50%;
                            width: auto;
                            height: 12px;
                            z-index: 99;
                            &.bought{
                                line-height: 12px;
                                padding: 0 3px;
                                font-size: 8px;
                                color: #FFFFFF;
                                white-space: nowrap;
                                border-radius: 6px 6px 6px 1px;
                                background: linear-gradient(90deg, #FF8882 0%, #FF5048 100%);
                            }
                            &.corner{
                                background: transparent;
                                img{
                                    width: auto;
                                    height: 12px;
                                    object-fit: cover;
                                    border: 0;
                                }
                            }
                            &.none{
                                display: none;
                            }
                        }
                        .van-image{
                            width: 45px;
                            height: 45px;
                        }
                    }
                    .gridName{
                        font-size: 11px;
                        color: #333333;
                        font-weight: 600;
                        margin-top: 5px;
                    }
                    .bottomTips{
                        position: absolute;
                        top: 37px;
                        padding: 0 5px;
                        height: 12px;
                        background: #FF5048;
                        border-radius: 6px;
                        font-size: 9px;
                        font-weight: 500;
                        color: #FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 1px;
                    }
                }
            }
            .scrollBarBox{
                width: 100%;
                height: 10px;
                .scrollBack{
                    position: absolute;
                    margin-left: -20px;
                    left: 50%;
                    width: 40px;
                    height: 4px;
                    background: #F5F5F5;
                    border-radius: 999px;
                    overflow: hidden;
                    .scrollBar{
                        width: 25px;
                        height: 4px;
                        background: #169AFF;
                        border-radius: 999px;
                    }
                }
            }
        }
        .gridVisual::-webkit-scrollbar {
            display: none;
        }
    }
    .banner{
        width: 100%;
        height: 58px;
        padding: 0 14px 8px;
        background: #F5F5F5;
        img{
            width: 100%;
            height: 50px;
            border-radius: 35px;
            object-fit: cover;
        }
    }
    .informationPart, .coldPart, .poissonPart, .bigReportPart, .fullForecastPart, .overseasPart{
        width: 100%;
        padding-bottom: 8px;
        background: #F5F5F5;
    }
    .overseasPart{
        width: 100%;
        padding: 0 14px 8px;
    }
    .placeholder{
        width: 100%;
        height: 35px;
        // background: #F5F5F5;
    }
}
.corpusDark {
    min-height: 100vh;
    background: #191919;
    .van-notice-bar{
        background: #191919;
        color: #169AFF;
    }
    .gridBox {
        background: #191919;
        .gridVisual {
            background: #232323;
            .gridUl {
                .gridLi {
                    /deep/.van-grid-item__content {
                        background: #232323;
                    }
                    .gridName {
                        color: #d3d3d3;
                    }
                }
            }
            .scrollBarBox {
                .scrollBack {
                    background: #232323;
                }
            }
        }
    }
    .informationPart, .coldPart, .poissonPart, .bigReportPart, .fullForecastPart, .overseasPart {
        background: #191919;
    }
}
</style>
